<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Bar Graph Source</mat-label>
    <input
      autocomplete="off"
      type="text"
      formControlName="value"
      id="barGraphSource"
      lcsStaticSelect
      [lcsSingleSelect]="barGraphSourceSelect"
      [lcsStaticSelectValue]="form.get('value')?.value"
      [required]="true"
      />
      <lcs-static-select #barGraphSourceSelect [displayWith]="barGraphSourceDisplayWith">
        @for (barGraphSource of barGraphSource; track barGraphSource) {
          <lcs-option [value]="barGraphSource">
            {{ barGraphSource }}
          </lcs-option>
        }
      </lcs-static-select>
    </mat-form-field>
  </ng-container>
